import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly standardName = 'Intosite';
  private readonly embeddedModeTitle = 'Visual Information Navigator';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(_routerState: RouterStateSnapshot): void {
    const isFromOpcenter = (!!window.opener && window.opener.self !== window.opener.top)
      || sessionStorage.getItem('fromOpcenter') === 'true';

    if (isFromOpcenter) {
      sessionStorage.setItem('fromOpcenter', 'true');
    }

    this.title.setTitle(isFromOpcenter ? this.embeddedModeTitle : this.standardName);
  }
}
